<template xmlns="http://www.w3.org/1999/html">
  <main class="assignment-add-page">
    <div class="uk-width-5-5">
      <CompanyBreadcrumb
          :aria-label="$t(isEditMode ? 'general.edit_assignment' : 'menu.company_dashboard.create_assignment')"
          :home-aria-label="$t('general.home')"
          :items="breadcrumbItems"
      />

      <div class="section-header mb-lg-2 border-0 uk-flex-middle assignment-page-header">
        <div class="section-header-left">
          <h2 class="assignment-page-title">
            <span>{{ $t(isEditMode ? 'general.edit_assignment' : 'general.new_assignment') }}</span></h2>
        </div>
      </div>
      <template v-if="errorMessages">
        <div v-for="(error, index) in errorMessages" :key="index" class="card assignment-alert-card">
          <div class="uk-alert-danger" uk-alert>
            <a class="uk-alert-close" uk-close></a>
            <p>
              <i class="uil-exclamation-triangle"></i> {{ error }}
            </p>
          </div>
        </div>
      </template>
      <div v-if="successMessage" class="card assignment-alert-card">
        <div class="uk-alert-success" uk-alert>
          <a class="uk-alert-close" uk-close></a>
          <p>
            <i class="uil-check"></i> {{ successMessage }}
          </p>
        </div>
      </div>
      <div class="card assignment-add-card">
        <div class="assignment-stepper-wrap">
          <StepperBreadcrumb :active-index="activeTabIndex"
                             :aria-label="$t(isEditMode ? 'general.edit_assignment' : 'general.new_assignment')"
                             :items="stepperItems"
                             divider
                             expand
                             @change="onStepperChange"
          />
        </div>

        <default-loading v-show="showLoading"></default-loading>
        <div v-show="!showLoading">
          <div class="card-body assignment-form-body">
            <div class="assignment-tab-panels" style="touch-action: pan-y pinch-zoom">
              <!--tab: özellikler-->
              <div v-show="activeTabIndex === 0">
                <div class="row">
                  <div class="col-xl-9 m-auto">
                    <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="course_title">{{
                          $t('general.assignment_name')
                        }}<span class="required">*</span></label>
                      <div class="col-md-9">
                        <input id="course_title" v-model="name" class="form-control" required="" type="text"/>
                      </div>
                    </div>
                    <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="short_description">{{
                          $t('collectionDetail.content_description')
                        }} <span class="required">*</span><i
                            :uk-tooltip="'title: ' + $t('general.description-max-1000')"
                            class="uil-info-circle ml-1"></i>
                        <br/>({{ textarea_length }} / 1000)
                      </label>
                      <div class="col-md-9">
                        <textarea id="short_description" v-model="description" class="form-control" maxlength="1000"
                                  name="short_description"></textarea>
                      </div>
                    </div>
                    <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label">{{
                          $t("general.instructors")
                        }}</label>
                      <div class="col-md-9">
                        <app-multiselect v-model="selectedInstructors"
                                         :allow-empty="true"
                                         :close-on-select="false"
                                         :is-disabled="instructorsLoading"
                                         :is-multiple="true"
                                         :options="instructorOptions"
                                         :placeholder="$t('general.select_instructor')"
                                         label="name"
                                         track-by="id"
                        />
                      </div>
                    </div>
                    <div class="form-group row mb-3">
                      <label class="col-md-3 col-form-label" for="logo">{{
                          $t('collectionDetail.cover_image')
                        }}<span class="required">*</span></label>
                      <div class="col-md-9">
                        <div uk-alert>
                          <a class="uk-alert-close" uk-close></a>
                          <h5><i class="uil-comment-info-alt"></i> {{ $t('general.information') }}</h5>
                          <p v-html="$t('general.catalog_cover_image_info', {
                            formats: '<b>.jpg, .png, .gif</b>',
                            dimensions: '<b>521x288</b>'
                          })"></p>
                        </div>
                        <div class="assignment-cover-photo">
                          <img :src="getImageUrl()" alt="" class="assignment-cover-photo__img"/>
                          <input id="cover_photo_input"
                                 ref="coverPhotoInput"
                                 accept="image/jpeg, image/jpg, image/png, image/gif"
                                 class="d-none" type="file"
                                 @change="processFile($event)"
                                 @click="onCoverPhotoInputClick"/>
                          <button class="assignment-cover-photo__btn"
                                  type="button" @click="triggerCoverPhotoInput">
                            <i aria-hidden="true" class="uil-image"></i>
                            <span>{{ $t("general.image_change") }}</span>
                          </button>
                        </div>
                        <ai-cover-image-generator :max-size-mb="15"
                                                  file-prefix="ai-assignment-cover"
                                                  @image-selected="handleAiCoverImageSelected"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="assignment-footer">
                  <button class="uk-button uk-button-primary small assignment-btn" type="button"
                          @click="validateAndSwitch(1)">
                    <i class="icon-feather-arrow-right"></i> {{ $t('general.save_and_continue') }}
                  </button>
                </div>
              </div>
              <!--tab: eğitim-->
              <div v-show="activeTabIndex === 1">
                <div class="row">
                  <div class="col-md-12">
                    <div v-if="showModalLearning || isEditMode" id="modal_learning"
                         class="uk-modal-full uk-modal assignment-modal" uk-modal="">
                      <div class="uk-modal-footer bggray assignment-modal-header">
                        <h3 class="assignment-modal-title">
                          <i class="uil-presentation-plus"></i> {{ $t('general.select_content') }}
                        </h3>
                        <button class="uk-button uk-button-default small uk-modal-close assignment-modal-close"
                                type="button">
                          <i class="uil-times"></i> {{ $t("general.close") }}
                        </button>
                      </div>

                      <div class="uk-modal-dialog bggray assignment-modal-body">
                        <Content :selected_items="all_selected_educations" :show_exam="true" :show_program="true"
                                 :show_survey="true" :with_competencies="true"
                                 @addNewEducation="addContentToAssignment($event)"
                                 @removeEducation="removeContentFromAssignment($event)"/>
                      </div>
                    </div>

                    <div class="assignment-content-card">
                      <div class="assignment-content-toolbar">
                        <div class="assignment-content-toggle">
                          <label class="col-form-label" for="can_open_contents_in_order">
                            {{ $t('general.sequential-content') }}
                          </label>
                          <label class="uk-switch" for="can_open_contents_in_order">
                            <input id="can_open_contents_in_order" v-model="can_open_contents_in_order"
                                   :disabled="isEditMode && disabledAddContent" type="checkbox"/>
                            <div class="uk-switch-slider"></div>
                          </label>
                        </div>
                        <button :disabled="isEditMode && disabledAddContent"
                                class="btn btn-info btn-sm assignment-select-content-btn"
                                uk-toggle="target: #modal_learning">
                          <i class="uil-plus m-0"></i> {{ $t('general.select_content') }}
                          <span class="required">*</span>
                        </button>
                      </div>
                      <div v-if="!educations || educations.length == 0" class="content-list-empty">
                        <i aria-hidden="true" class="uil-folder-open content-list-empty__icon"></i>
                        <p class="content-list-empty__text">{{ $t('general.no-content-selected') }}</p>
                      </div>
                      <draggable v-else :disabled="isEditMode && disabledAddContent" :list="educations"
                                 class="content-list"
                                 group="education_widget">
                        <div v-for="(education, index) in educations"
                             :key="'assignment_content_list_' + index"
                             class="content-item"
                        >
                          <!-- Badge -->
                          <span class="content-item__badge">{{ $t(education.name) }}</span>

                          <!-- Row: drag + order + title + actions -->
                          <div class="content-item__row">
                            <div class="content-item__drag">
                              <i aria-hidden="true" class="uil-grip-horizontal-line"></i>
                            </div>
                            <span class="content-item__order">{{ index + 1 }}</span>
                            <p class="content-item__title">{{ education.title }}</p>

                            <!-- Competency tag (inline) -->
                            <span v-if="education.competencies?.length > 0"
                                  :class="{ 'strikethrough': is_competency_selected }"
                                  :uk-tooltip="getCompetencyTooltip(education.competencies)"
                                  class="content-item__competency-tag"
                            >
                              <i aria-hidden="true" class="uil-award"></i>
                              {{ $t('general.competencies_to_be_acquired') }}
                            </span>

                            <div class="content-item__actions">
                              <button class="content-item__action-btn content-item__action-btn--settings"
                                      type="button"
                                      @click="showCustomize(education.id, index)"
                              >
                                <i aria-hidden="true" class="icon-feather-settings"></i>
                                <span>{{ $t('general.customize') }}</span>
                              </button>
                              <button :uk-tooltip="'title: ' + $t('general.deselect')"
                                      class="content-item__action-btn content-item__action-btn--remove"
                                      type="button"
                                      @click="removeContentFromAssignment(education, index)"
                              >
                                <i aria-hidden="true" class="icon-feather-trash"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </draggable>

                    </div>

                    <hr>
                    <div class="row mb-2">
                      <div class="col-md-4 d-flex align-items-center">
                        <div class="row">
                          <div class="col-md-2">
                            <label class="uk-switch" for="assigned_competencies">
                              <input id="assigned_competencies" v-model="is_competency_selected"
                                     :disabled="isEditMode && disabledAddContent"
                                     class="mr-2" type="checkbox"
                                     uk-toggle="target: #assigned_competencies_list"/>
                              <div class="uk-switch-slider"></div>
                            </label>
                          </div>
                          <label class="col-form-label col-md-9 pt-0 ml-2" for="assigned_competencies">
                            {{ $t('general.when_assignment_completed_competence_be_gained') }}
                            <i :uk-tooltip="'title: ' + $t('general.competency-info')" class="uil-info-circle"></i>
                          </label>
                        </div>
                      </div>
                      <div class="col-md-8">
                        <div id="assigned_competencies_list" class="mb-2 mx-2 bggray p-4 card" hidden>
                          <div class="row">
                            <div class="col-md-12">
                              <label for=""><i class="uil-star"></i>
                                {{ $t('general.competencies_to_be_acquired') }}</label>
                              <CompetenciesInputSelection v-model="selectedCompetencies"/>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div class="assignment-footer">
                      <button class="uk-button uk-button-outline small assignment-btn" type="button"
                              @click="switcherChange(0)">
                        <i class="icon-feather-arrow-left"></i>{{ $t("general.previous") }}
                      </button>
                      <button class="uk-button uk-button-primary small assignment-btn" type="button"
                              @click="validateAndSwitch(2)">
                        <i class="icon-feather-arrow-right"></i> {{ $t('general.save_and_continue') }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!--tab: kullanıcılar-->
              <div v-show="activeTabIndex === 2">
                <UserGroupSelection :added_users="isEditMode ? added_users : undefined"
                                    :assignment_id="isEditMode ? $route.params.id : undefined"
                                    :checked_groups="checked_groups"
                                    :checked_users="checked_users"
                                    :is-user-list-included="true"
                                    :show_only_unassigned_users="isEditMode ? show_only_unassigned_users : undefined"
                                    @setCheckedGroups="($event) => { checked_groups = $event }"
                                    @setCheckedUsers="($event) => { checked_users = $event }"/>

                <div class="assignment-footer">
                  <button class="uk-button uk-button-outline small assignment-btn" type="button"
                          @click="switcherChange(1)">
                    <i class="icon-feather-arrow-left"></i> {{ $t("general.previous") }}
                  </button>
                  <button class="uk-button uk-button-primary small assignment-btn" type="button"
                          @click="validateAndSwitch(3)">
                    <i class="icon-feather-arrow-right"></i> {{ $t('general.save_and_continue') }}
                  </button>
                </div>
              </div>
              <!--tab: hediye-->
              <div v-if="$isGiftVisible" v-show="activeTabIndex === 3">
                <div class="assignment-gift-section">
                  <div class="assignment-gift-toggle">
                    <div class="assignment-gift-toggle__label">
                      <i aria-hidden="true" class="icon-feather-gift"></i>
                      <span>{{ $t('general.give_a_gift_at_the_end') }}</span>
                    </div>
                    <label class="uk-switch" for="gift-switch">
                      <input id="gift-switch" v-model="giftHasPresent" type="checkbox"/>
                      <div class="uk-switch-slider"></div>
                    </label>
                  </div>

                  <template v-if="giftHasPresent">
                    <div class="assignment-gift-rule">
                      <label class="assignment-gift-rule__label">
                        {{ $t('general.rule_for_earning_gift') }}<span class="required">*</span>
                      </label>
                      <multiple-select-input v-model="selectedGiftRule"
                                             :allow-empty="false"
                                             :multiple="false"
                                             :searchable="false"
                                             :show-labels="false"
                                             :values="giftRuleOptions"
                                             class="assignment-gift-rule__dropdown"
                      />
                    </div>

                    <div class="assignment-gift-list">
                      <div id="modal_gifts" class="uk-modal-full uk-modal assignment-modal" uk-modal="">
                        <div class="uk-modal-footer bggray assignment-modal-header">
                          <h3 class="assignment-modal-title">
                            <i class="uil-presentation-plus"></i>
                            {{ $t("gift.management") }}
                          </h3>
                          <button class="uk-button uk-button-default small uk-modal-close assignment-modal-close"
                                  type="button">
                            <i class="uil-times"></i> {{ $t("general.close") }}
                          </button>
                        </div>
                        <div class="uk-modal-dialog bggray assignment-modal-body">
                          <Gift :selected_items="all_selected_gifts" @addNewGift="addGiftToAssignment($event)"></Gift>
                        </div>
                      </div>

                      <button class="btn btn-secondary assignment-gift-add-btn" type="button"
                              uk-toggle="target: #modal_gifts">
                        <i aria-hidden="true" class="uil-plus"></i> {{ $t('general.add_gift') }}<span
                          class="required">*</span>
                      </button>

                      <draggable :list="gifts" class="assignment-gift-items" group="gifts_widget" tag="ul">
                        <li v-for="(item, index) in gifts" :key="'gift-' + item.id" class="assignment-gift-item">
                          <div class="assignment-gift-item__drag">
                            <i aria-hidden="true" class="uil-ellipsis-v"></i>
                          </div>
                          <img :src="item.image" alt="" class="assignment-gift-item__img"/>
                          <div class="assignment-gift-item__body">
                            <span class="assignment-gift-item__name">{{ item.name }}</span>
                            <span class="assignment-gift-item__rank">
                              <i aria-hidden="true" class="uil-trophy"></i>
                              {{ index + 1 }}. {{ $t('general.winner') }}
                            </span>
                          </div>
                          <button :aria-label="$t('general.delete')" class="assignment-gift-item__remove"
                                  type="button"
                                  @click="removeGiftFromAssignment(item.id)">
                            <i class="icon-feather-x"></i>
                          </button>
                        </li>
                      </draggable>
                    </div>
                  </template>
                </div>
                <div class="assignment-footer">
                  <button class="uk-button uk-button-outline small assignment-btn" type="submit"
                          @click="switcherChange(2)">
                    <i class="icon-feather-arrow-left"></i> {{ $t("general.previous") }}
                  </button>
                  <button class="uk-button uk-button-primary small assignment-btn" type="submit"
                          @click="validateAndSwitch(4)">
                    <i class="icon-feather-arrow-right"></i> {{ $t('general.save_and_continue') }}
                  </button>
                </div>
              </div>
              <!--tab: ayarlar-->
              <div v-show="settingsTabIndex === activeTabIndex">
                <div class="container">
                  <div class="row">
                    <div class="col-md-3">
                      <ul class="uk-tab-right uk-tab sidemenu assignment-settings-menu"
                          uk-switcher="connect: #settings-tab ; animation: uk-animation-slide-left-medium, uk-animation-slide-right-medium">
                        <li class="uk-active">
                          <a href="#"><i class="uil-keyboard"></i>
                            <b>{{ $t('general.assignment_settings') }}</b></a>
                        </li>
                        <li>
                          <a href="#"><i class="uil-envelope-edit"></i>
                            <b>{{ $t('general.message_settings') }} </b></a>
                        </li>
                      </ul>
                    </div>

                    <div class="col-md-9">
                      <ul id="settings-tab" class="uk-switcher">
                        <li class="uk-active">
                          <div class="form-group row mb-2">
                            <label class="col-md-6 col-form-label" for="course_title">
                              {{ $t('general.program_option') }}<span class="required">*</span></label>
                            <div class="col-md-6">
                              <multiple-select-input v-model="selectedCompulsory"
                                                     :allow-empty="false"
                                                     :multiple="false"
                                                     :searchable="false"
                                                     :show-labels="false"
                                                     :values="compulsoryOptions"
                                                     class="assignment-settings__dropdown"
                              />
                            </div>
                          </div>

                          <div class="form-group row mb-2">
                            <label class="col-md-6 col-form-label" for="website_keywords">
                              {{ $t('general.certificate_selection') }}
                              <i :uk-tooltip="'title: ' + $t('general.certificate-info')"
                                 class="uil-info-circle"></i></label>
                            <div class="col-md-6">
                              <multiple-select-input v-model="certificate"
                                                     :allow-empty="true"
                                                     :multiple="false"
                                                     :searchable="true"
                                                     :show-labels="false"
                                                     :values="certificate_items"
                                                     class="assignment-settings__dropdown"
                              />
                            </div>
                          </div>

                          <div class="form-group row mb-2">
                            <label class="col-md-6 col-form-label">
                              {{ $t('general.menu_selection') }}
                            </label>
                            <div class="col-md-6">
                              <multiple-select-input v-model="selectedWidgets"
                                                     :allow-empty="true"
                                                     :multiple="true"
                                                     :searchable="true"
                                                     :show-labels="false"
                                                     :values="widgetItems"
                                                     class="assignment-settings__dropdown"
                                                     label="title"
                              />
                            </div>
                          </div>

                          <hr/>

                          <div class="form-group row mb-2">
                            <label class="col-md-6 col-form-label" for="website_keywords">
                              {{ $t('general.feature_the_training') }}
                              <i :uk-tooltip="'title: ' + $t('general.feature-the-training-info')"
                                 class="uil-info-circle"></i>
                            </label>
                            <div class="col-md-6">
                              <label class="uk-switch" for="default-one-cikanlar">
                                <input id="default-one-cikanlar" v-model="highlight_education" type="checkbox"/>
                                <div class="uk-switch-slider"></div>
                              </label>
                            </div>
                          </div>

                          <div class="form-group row mb-2">
                            <label class="col-md-6 col-form-label" for="mandatory_completion">
                              {{ $t('general.show-on-system-start') }}
                              <i :uk-tooltip="'title: ' + $t('general.mandatory-assignment-info')"
                                 class="uil-info-circle"></i>
                            </label>
                            <div class="col-md-6">
                              <label class="uk-switch" for="mandatory_completion">
                                <input id="mandatory_completion" v-model="mandatory_completion" type="checkbox"/>
                                <div class="uk-switch-slider"></div>
                              </label>
                            </div>
                          </div>

                          <hr/>

                          <div class="form-group row mb-2 input-checkbox">
                            <DateRangePicker :end-date.sync="end_date" :end-label="$t('general.final_completion_date')"
                                             :end-tooltip="$t('general.end-date-info')"
                                             :min-start-date="setMinimumDate()"
                                             :required="true" :start-date.sync="start_date"
                                             :start-label="$t('general.start_day')"
                                             :start-tooltip="$t('general.start-date-info')"/>

                            <div class="col-md-12">
                              <div v-if="!isClassRoomEducationSelected" class="form-group row mb-2">
                                <label class="col-md-6 col-form-label" for="website_keywords">{{
                                    $t('general.repetition')
                                  }}
                                  <i :uk-tooltip="'title: ' + $t('general.repeatable-info')" class="uil-info-circle">
                                  </i>
                                </label>
                                <div class="col-md-6">
                                  <label class="uk-switch" for="repeatable">
                                    <input id="repeatable" v-model="repeatable" :disabled="isEditMode" type="checkbox"/>
                                    <div :style="isEditMode ? 'cursor: not-allowed' : ''"
                                         class="uk-switch-slider"></div>
                                  </label>
                                </div>
                              </div>
                              <div v-if="repeatable" class="form-group row mb-2">
                                <label class="col-md-6 col-form-label" for="website_keywords">
                                  {{ $t('general.number_of_repetitions') }}
                                  <span class="required">*</span>
                                  <i class="uil-info-circle"></i>
                                </label>
                                <div class="col-md-6">
                                  <input v-model="repetition_no" class="form-control assignment-settings__number-sm"
                                         min="0"
                                         type="number" @keypress="isNumber($event)"/>
                                </div>
                              </div>

                              <template v-if="repetition_no && repeatable">
                                <hr/>
                                <template v-for="i in parseInt(repetition_no)">
                                  <div v-if="'row_key' + i" :key="'row_key' + i" class="row w-100 mb-3">
                                    <div :key="'row_number_' + i"
                                         class="col-md-2 d-flex align-items-end justify-content-center">
                                      <span class="row_number">{{ i }}.</span>
                                    </div>
                                    <div :key="'start_date_index_' + i" class="col-md-5">
                                      <label class="col-form-label" for="pass">{{ $t('general.start_day') }}<span
                                          class="required">*</span>
                                      </label>
                                      <input v-if="repetition_date[i]" id="pass" v-model="repetition_date[i].start_date"
                                             :min="setMinimumDate()" class="form-control mb-0" type="date"/>
                                    </div>
                                    <div :key="'end_date_index_' + i" class="col-md-5">
                                      <label class="col-form-label" for="pass">
                                        {{ $t('general.final_completion_date') }}<span class="required">*</span>
                                      </label>
                                      <input v-if="repetition_date[i]" id="pass" v-model="repetition_date[i].end_date"
                                             :min="repetition_date[i].start_date
                                          ? setMinimumDate(
                                            repetition_date[i].start_date
                                          )
                                          : setMinimumDate()
                                          " class="form-control mb-0" type="date"/>
                                    </div>
                                  </div>
                                </template>
                                <hr/>
                              </template>

                              <div class="form-group row mb-2">
                                <label class="col-md-6 col-form-label" for="following_assignment">
                                  {{ $t('general.next-assignment') }}
                                  <i :uk-tooltip="'title: ' + $t('general.next-assignment-info')"
                                     class="uil-info-circle"></i>
                                </label>
                                <div class="col-md-6">
                                  <multiple-select-input v-model="following_assignment_id"
                                                         :allow-empty="true"
                                                         :multiple="false"
                                                         :searchable="true"
                                                         :show-labels="false"
                                                         :values="assignmentsList"
                                                         class="assignment-settings__dropdown"
                                  />
                                </div>
                              </div>
                              <div v-if="following_assignment_id" class="form-group row mb-2">
                                <label class="col-md-6 col-form-label" for="assign_after_days">
                                  {{ $t('general.assign-after-days') }}
                                  <span class="required">*</span>
                                  <i :uk-tooltip="'title: ' + $t('general.assign-after-days-info')"
                                     class="uil-info-circle"></i>
                                </label>
                                <div class="col-md-6">
                                  <multiple-select-input v-if="!showCustomDayInput"
                                                         v-model="assign_after_days"
                                                         :allow-empty="false"
                                                         :multiple="false"
                                                         :searchable="false"
                                                         :show-labels="false"
                                                         :values="assignAfterDaysOptions"
                                                         class="assignment-settings__dropdown"
                                                         label="label"
                                                         track-by="value"
                                  />
                                  <div v-if="showCustomDayInput" class="input-group">
                                    <input v-model.number="customDays" :placeholder="$t('general.day-count')"
                                           class="form-control" min="1" type="number" @keypress="isNumber($event)"/>
                                    <div class="input-group-append">
                                      <button class="btn btn-outline-secondary" type="button"
                                              @click="showCustomDayInput = false; assign_after_days = null; customDays = null">
                                        <i class="uil-multiply"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                          <hr/>

                          <div v-if="durationFeatureIsEnabled">
                            <div class="form-group domain row mb-2">
                              <label class="col-md-6 col-form-label" for="assigment_duration">
                                {{ $t('general.duration') }} <i class="uil-info-circle"></i>
                              </label>
                              <div class="col-md-6">
                                <div class="assignment-settings__duration">
                                  <input id="assigment_duration" v-model="duration"
                                         class="form-control assignment-settings__duration-input"
                                         min="0" type="number" @keypress="isNumber($event)"/>
                                  <span class="assignment-settings__duration-unit">{{ $t("general.minutes") }}</span>
                                </div>
                              </div>
                            </div>
                            <hr/>
                          </div>

                          <div class="form-group row mb-2">
                            <label class="col-md-6 col-form-label" for="survey_required">{{
                                $t('general.add_survey_after_the_training')
                              }}
                              <i :uk-tooltip="'title: ' + $t('general.survey-info')"
                                 class="uil-info-circle"></i></label>
                            <div class="col-md-6">
                              <label class="uk-switch" for="survey_required">
                                <input id="survey_required" v-model="survey_required" type="checkbox"/>
                                <div class="uk-switch-slider"></div>
                              </label>
                            </div>
                          </div>

                          <div v-show="survey_required" class="form-group row mb-2">
                            <label class="col-md-6 col-form-label" for="website_keywords">
                              {{ $t('general.select_evaluation_survey') }}<span class="required">*</span>
                            </label>
                            <div class="col-md-6">
                              <multiple-select-input v-model="survey_id"
                                                     :allow-empty="false"
                                                     :multiple="false"
                                                     :searchable="true"
                                                     :show-labels="false"
                                                     :values="survey_items"
                                                     class="assignment-settings__dropdown"
                              />
                            </div>
                          </div>
                          <hr/>

                          <div v-if="!isClassRoomEducationSelected" class="form-group row mb-2">
                            <label class="col-md-6 col-form-label" for="website_keywords">{{
                                $t('general.show_the_top_rankings_list')
                              }}
                              <i :uk-tooltip="'title: ' + $t('general.leaderboard-info')" class="uil-info-circle">
                              </i>
                            </label>
                            <div class="col-md-6">
                              <label class="uk-switch" for="appear_top">
                                <input id="appear_top" v-model="appear_top" type="checkbox"/>
                                <div class="uk-switch-slider"></div>
                              </label>
                            </div>
                          </div>

                          <div class="form-group row mb-2">
                            <label class="col-md-6 col-form-label" for="has_feedbacks">
                              {{ $t('general.experience_sharing') }}
                              <i :uk-tooltip="'title: ' + $t('general.experience-sharing-info')"
                                 class="uil-info-circle"></i>
                            </label>
                            <div class="col-md-6">
                              <label class="uk-switch" for="has_feedbacks">
                                <input id="has_feedbacks" v-model="has_feedbacks" type="checkbox"/>
                                <div class="uk-switch-slider"></div>
                              </label>
                            </div>
                          </div>

                          <div class="form-group row mb-2">
                            <label class="col-md-6 col-form-label" for="can_be_watched_again">
                              {{ $t('general.allow_users_to_watch_the_training_again') }}
                              <i :uk-tooltip="'title: ' + $t('general.completed-training-info')"
                                 class="uil-info-circle"></i>
                            </label>
                            <div class="col-md-6">
                              <label class="uk-switch" for="can_be_watched_again">
                                <input id="can_be_watched_again" v-model="can_be_watched_again" type="checkbox"/>
                                <div class="uk-switch-slider"></div>
                              </label>
                            </div>
                          </div>

                          <!-- Status toggle (edit mode only) -->
                          <div v-if="isEditMode" class="form-group row mb-2">
                            <label class="col-md-6 col-form-label" for="assignment_status">
                              {{ assignment_status_action_label }}
                            </label>
                            <div class="col-md-6">
                              <label class="uk-switch" for="assignment_status">
                                <input id="assignment_status" v-model="assignment_status_toggle" type="checkbox"/>
                                <div class="uk-switch-slider"></div>
                              </label>
                            </div>
                          </div>
                        </li>

                        <li>
                          <!-- E-posta gönder -->
                          <div class="msg-settings__section">
                            <div class="msg-settings__switch-row">
                              <label class="msg-settings__switch-label" for="send_mail_notification">
                                <i aria-hidden="true" class="uil-envelope msg-settings__switch-icon"></i>
                                {{ $t('general.send_email') }}
                              </label>
                              <label class="uk-switch" for="send_mail_notification">
                                <input id="send_mail_notification" v-model="send_mail_notification" type="checkbox"/>
                                <div class="uk-switch-slider"></div>
                              </label>
                            </div>

                            <template v-if="send_mail_notification && !send_mobile_notification">
                              <div class="msg-settings__sub-panel">
                                <div class="assignment-settings__notif-row">
                                  <div class="assignment-settings__notif-label">
                                    {{ $t('general.notification_send_time') }}
                                  </div>
                                  <div class="assignment-settings__notif-radios">
                                    <label class="assignment-settings__radio-label">
                                      <input v-model="notification_send_type" class="assignment-settings__radio-input"
                                             type="radio"
                                             value="now"/>
                                      <span class="assignment-settings__radio-text">
                                        {{ $t('general.send_now') }}
                                      </span>
                                    </label>
                                    <label class="assignment-settings__radio-label">
                                      <input v-model="notification_send_type" class="assignment-settings__radio-input"
                                             type="radio"
                                             value="scheduled"/>
                                      <span :title="$t('general.notification_date_before_start_info')"
                                            class="assignment-settings__radio-text tooltip-wrap">
                                        {{ $t('general.scheduled_send') }}
                                        <span class="tooltip-text">
                                          {{ $t('general.notification_date_before_start_info') }}
                                        </span>
                                      </span>
                                    </label>
                                  </div>
                                  <div v-if="notification_send_type === 'scheduled'"
                                       class="assignment-settings__notif-picker">
                                    <VueCtkDateTimePicker id="mail_notification_scheduled_at"
                                                          v-model="notification_scheduled_at"
                                                          :format="'YYYY-MM-DD HH:mm:ss'"
                                                          :min-date="setMinimumDate()"
                                                          :no-button-now="true"/>
                                  </div>
                                </div>

                                <div class="msg-settings__reminder-list">
                                  <label class="msg-settings__reminder-item">
                                    <input v-model="isRemindEntered" class="msg-settings__reminder-checkbox"
                                           name="notification1" type="checkbox">
                                    <span class="msg-settings__reminder-text">
                                      {{ $t('general.remind_if_not_entered_prefix') }}
                                      <input v-model="remind_if_not_entered_x_days"
                                             class="msg-settings__reminder-number" max="365" min="1" type="number">
                                      {{ $t('general.day_unit') }}
                                      {{ $t('general.remind_if_not_entered_mid') }}
                                      <input v-model="remind_if_not_entered_every_y_days"
                                             class="msg-settings__reminder-number" max="365" min="1" type="number">
                                      {{ $t('general.every_n_days_send_message') }}
                                    </span>
                                  </label>
                                  <label class="msg-settings__reminder-item">
                                    <input v-model="isRemindStarting" class="msg-settings__reminder-checkbox"
                                           name="notification2" type="checkbox">
                                    <span class="msg-settings__reminder-text">
                                      {{ $t('general.remind_before_start_prefix') }}
                                      <input v-model="remind_before_starting_x_days"
                                             class="msg-settings__reminder-number" max="365" min="1" type="number">
                                      {{ $t('general.days_before') }}
                                      {{ $t('general.every') }}
                                      <input v-model="remind_before_starting_every_y_days"
                                             class="msg-settings__reminder-number" max="365" min="1" type="number">
                                      {{ $t('general.every_n_days_send_message') }}
                                    </span>
                                  </label>
                                  <label class="msg-settings__reminder-item">
                                    <input v-model="isRemindEnding" class="msg-settings__reminder-checkbox"
                                           name="notification3" type="checkbox">
                                    <span class="msg-settings__reminder-text">
                                      {{ $t('general.remind_before_end_prefix') }}
                                      <input v-model="remind_before_ending_x_days" class="msg-settings__reminder-number"
                                             max="365" min="1" type="number">
                                      {{ $t('general.days_before') }}
                                      {{ $t('general.every') }}
                                      <input v-model="remind_before_ending_every_y_days"
                                             class="msg-settings__reminder-number" max="365" min="1" type="number">
                                      {{ $t('general.every_n_days_send_message') }}
                                    </span>
                                  </label>
                                </div>
                              </div>
                            </template>
                          </div>

                          <hr class="msg-settings__divider"/>

                          <!-- Mobil bildirim gönder -->
                          <div class="msg-settings__section">
                            <div class="msg-settings__switch-row">
                              <label class="msg-settings__switch-label" for="send_mobile_notification">
                                <i aria-hidden="true" class="uil-mobile-android msg-settings__switch-icon"></i>
                                {{ $t('general.send_mobile_notification') }}
                              </label>
                              <label class="uk-switch" for="send_mobile_notification">
                                <input id="send_mobile_notification" v-model="send_mobile_notification"
                                       type="checkbox"/>
                                <div class="uk-switch-slider"></div>
                              </label>
                            </div>

                            <template
                                v-if="send_mobile_notification || (send_mobile_notification && send_mail_notification)">
                              <div class="msg-settings__sub-panel">
                                <div class="assignment-settings__notif-row">
                                  <div class="assignment-settings__notif-label">
                                    {{ $t('general.notification_send_time') }}
                                  </div>
                                  <div class="assignment-settings__notif-radios">
                                    <label class="assignment-settings__radio-label">
                                      <input v-model="notification_send_type" class="assignment-settings__radio-input"
                                             type="radio"
                                             value="now"/>
                                      <span class="assignment-settings__radio-text">
                                        {{ $t('general.send_now') }}
                                      </span>
                                    </label>
                                    <label class="assignment-settings__radio-label">
                                      <input v-model="notification_send_type" class="assignment-settings__radio-input"
                                             type="radio"
                                             value="scheduled"/>
                                      <span :title="$t('general.notification_date_before_start_info')"
                                            class="assignment-settings__radio-text tooltip-wrap">
                                        {{ $t('general.scheduled_send') }}
                                        <span class="tooltip-text">
                                          {{ $t('general.notification_date_before_start_info') }}
                                        </span>
                                      </span>
                                    </label>
                                  </div>
                                  <div v-if="notification_send_type === 'scheduled'"
                                       class="assignment-settings__notif-picker">
                                    <VueCtkDateTimePicker id="mobile_notification_scheduled_at"
                                                          v-model="notification_scheduled_at"
                                                          :format="'YYYY-MM-DD HH:mm:ss'"
                                                          :min-date="setMinimumDate()"
                                                          :no-button-now="true"/>
                                  </div>
                                </div>

                                <div class="msg-settings__reminder-list">
                                  <label class="msg-settings__reminder-item">
                                    <input v-model="isRemindEntered" class="msg-settings__reminder-checkbox"
                                           name="notification1_mobile" type="checkbox">
                                    <span class="msg-settings__reminder-text">
                                      {{ $t('general.remind_if_not_entered_prefix') }}
                                      <input v-model="remind_if_not_entered_x_days"
                                             class="msg-settings__reminder-number" max="365" min="1" type="number">
                                      {{ $t('general.day_unit') }}
                                      {{ $t('general.remind_if_not_entered_mid') }}
                                      <input v-model="remind_if_not_entered_every_y_days"
                                             class="msg-settings__reminder-number" max="365" min="1" type="number">
                                      {{ $t('general.every_n_days_send_message') }}
                                    </span>
                                  </label>
                                  <label class="msg-settings__reminder-item">
                                    <input v-model="isRemindStarting" class="msg-settings__reminder-checkbox"
                                           name="notification2_mobile" type="checkbox">
                                    <span class="msg-settings__reminder-text">
                                      {{ $t('general.remind_before_start_prefix') }}
                                      <input v-model="remind_before_starting_x_days"
                                             class="msg-settings__reminder-number" max="365" min="1" type="number">
                                      {{ $t('general.days_before') }}
                                      {{ $t('general.every') }}
                                      <input v-model="remind_before_starting_every_y_days"
                                             class="msg-settings__reminder-number" max="365" min="1" type="number">
                                      {{ $t('general.every_n_days_send_message') }}
                                    </span>
                                  </label>
                                  <label class="msg-settings__reminder-item">
                                    <input v-model="isRemindEnding" class="msg-settings__reminder-checkbox"
                                           name="notification3_mobile" type="checkbox">
                                    <span class="msg-settings__reminder-text">
                                      {{ $t('general.remind_before_end_prefix') }}
                                      <input v-model="remind_before_ending_x_days" class="msg-settings__reminder-number"
                                             max="365" min="1" type="number">
                                      {{ $t('general.days_before') }}
                                      {{ $t('general.every') }}
                                      <input v-model="remind_before_ending_every_y_days"
                                             class="msg-settings__reminder-number" max="365" min="1" type="number">
                                      {{ $t('general.every_n_days_send_message') }}
                                    </span>
                                  </label>
                                </div>
                              </div>
                            </template>
                          </div>

                          <hr class="msg-settings__divider"/>

                          <!-- Takvime ekle -->
                          <div class="msg-settings__section">
                            <div class="msg-settings__switch-row">
                              <label class="msg-settings__switch-label" for="can_be_added_to_calendar">
                                <i aria-hidden="true" class="uil-calendar-alt msg-settings__switch-icon"></i>
                                {{ $t('general.add_to_calendar') }}
                              </label>
                              <label class="uk-switch" for="can_be_added_to_calendar">
                                <input id="can_be_added_to_calendar" v-model="can_be_added_to_calendar"
                                       type="checkbox"/>
                                <div class="uk-switch-slider"></div>
                              </label>
                            </div>
                          </div>

                          <hr class="msg-settings__divider"/>

                          <!-- E-posta şablonu özelleştir -->
                          <div class="msg-settings__section">
                            <div class="msg-settings__switch-row">
                              <label class="msg-settings__switch-label" for="has_customized_template">
                                <i aria-hidden="true" class="uil-file-edit-alt msg-settings__switch-icon"></i>
                                {{ $t('general.customize-email-template') }}
                              </label>
                              <label class="uk-switch" for="has_customized_template">
                                <input id="has_customized_template" v-model="has_customized_template" type="checkbox"/>
                                <div class="uk-switch-slider"></div>
                              </label>
                            </div>

                            <template v-if="has_customized_template">
                              <div class="msg-settings__sub-panel">
                                <div class="msg-settings__template-field">
                                  <label class="msg-settings__template-label"
                                         for="mail_subject">{{ $t("general.heading") }}</label>
                                  <input id="mail_subject" v-model="mail_template.subject"
                                         :placeholder="$t('general.heading')"
                                         class="form-control"
                                         maxlength="255" type="text"/>
                                </div>

                                <div class="msg-settings__template-actions">
                                  <button id="uk_button_mail_codes" class="btn btn-secondary msg-settings__code-btn"
                                          type="button">
                                    <i class="uil-plus-circle"></i> {{ $t("mail.add_code") }}
                                  </button>
                                </div>

                                <div class="uk-width-large" uk-dropdown="toggle:#uk_button_mail_codes">
                                  <div class="uk-dropdown-grid uk-child-width-1-2@m" uk-grid>
                                    <div>
                                      <ul class="uk-nav uk-dropdown-nav">
                                        <template v-for="(code, i) in mail_template_codes">
                                          <template v-if="i < codeSlice()">
                                            <li class="uk-active">
                                              <a href="#">{{ $t(code.key_name) }}</a>
                                            </li>
                                            <li>
                                              <b>{{ code.code }}</b>
                                              <a href="#" @click="copyCode(code.code)"><i class="uil-copy-alt"></i>
                                                {{ $t("general.copy") }}</a>
                                            </li>
                                            <li class="uk-nav-divider"></li>
                                          </template>
                                        </template>
                                      </ul>
                                    </div>
                                    <div>
                                      <ul class="uk-nav uk-dropdown-nav">
                                        <template v-for="(code, i) in mail_template_codes">
                                          <template v-if="i >= codeSlice()">
                                            <li class="uk-active">
                                              <a href="#">{{ code.name }}</a>
                                            </li>
                                            <li>
                                              <b>{{ code.code }}</b>
                                              <a href="#" @click="copyCode(code.code)"><i class="uil-copy-alt"></i>
                                                {{ $t("general.copy") }}</a>
                                            </li>
                                            <li class="uk-nav-divider"></li>
                                          </template>
                                        </template>
                                      </ul>
                                    </div>
                                  </div>
                                </div>

                                <html-area v-if="mail_template.html != undefined"
                                           :company="company" :model="mail_template"
                                           @update="updateMailTemplate"></html-area>
                              </div>
                            </template>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="assignment-footer">
                    <button class="uk-button uk-button-outline small assignment-btn" type="submit"
                            @click="switcherChange(settingsTabIndex - 1)">
                      <i class="icon-feather-arrow-left"></i> {{ $t("general.previous") }}
                    </button>
                    <button class="uk-button uk-button-primary small assignment-btn" type="submit"
                            @click="validateAndSwitch(resultTabIndex)">
                      <i class="icon-feather-arrow-right"></i> {{ $t('general.save_and_continue') }}
                    </button>
                  </div>
                </div>
              </div>
              <!--tab: sonuç-->
              <div v-show="resultTabIndex === activeTabIndex">
                <div class="result-tab">
                  <!-- Header -->
                  <div class="result-tab__header">
                    <div class="result-tab__icon-wrap">
                      <i class="icon-feather-check-circle"></i>
                    </div>
                    <h3 class="result-tab__title">{{ $t('general.assignment_ready') }}!</h3>
                    <p class="result-tab__desc">{{ $t('general.save-assignment-info') }}</p>
                  </div>

                  <!-- Summary card -->
                  <div class="result-tab__card">
                    <div class="result-tab__card-header">
                      <img :src="getImageUrl()" alt="" class="result-tab__cover"/>
                    </div>

                    <ul class="result-tab__list">
                      <li class="result-tab__item">
                        <span class="result-tab__item-label">
                          <i aria-hidden="true" class="uil-tag-alt"></i>
                          {{ $t('general.assignment_name') }}
                        </span>
                        <span class="result-tab__item-value">{{ name }}</span>
                      </li>

                      <li v-if="checked_users.length > 0" class="result-tab__item">
                        <span class="result-tab__item-label">
                          <i aria-hidden="true" class="uil-users-alt"></i>
                          {{ $t('general.number_of_assigned_users') }}
                        </span>
                        <span class="result-tab__item-value result-tab__item-value--badge">{{
                            checked_users.length
                          }}</span>
                      </li>

                      <li v-if="checked_groups.length > 0" class="result-tab__item">
                        <span class="result-tab__item-label">
                          <i aria-hidden="true" class="uil-layer-group"></i>
                          {{ $t('general.assigned_group_count') }}
                        </span>
                        <span class="result-tab__item-value result-tab__item-value--badge">{{
                            checked_groups.length
                          }}</span>
                      </li>

                      <li class="result-tab__item">
                        <span class="result-tab__item-label">
                          <i aria-hidden="true" class="uil-gift"></i>
                          {{ $t('general.give_a_gift_at_the_end') }}
                        </span>
                        <span :class="giftHasPresent ? 'result-tab__item-value--yes' : 'result-tab__item-value--no'"
                              class="result-tab__item-value">
                          {{ giftHasPresent ? $t("general.yes") : $t("general.no") }}
                        </span>
                      </li>

                      <li class="result-tab__item">
                        <span class="result-tab__item-label">
                          <i aria-hidden="true" class="uil-trophy"></i>
                          {{ $t('general.top_rankings_list_display') }}
                        </span>
                        <span :class="appear_top ? 'result-tab__item-value--yes' : 'result-tab__item-value--no'"
                              class="result-tab__item-value">
                          {{ appear_top ? $t("general.yes") : $t("general.no") }}
                        </span>
                      </li>

                      <li class="result-tab__item">
                        <span class="result-tab__item-label">
                          <i aria-hidden="true" class="uil-calendar-alt"></i>
                          {{ $t('general.start_day') }}
                        </span>
                        <span class="result-tab__item-value">{{ start_date }}</span>
                      </li>

                      <li class="result-tab__item">
                        <span class="result-tab__item-label">
                          <i aria-hidden="true" class="uil-calendar-alt"></i>
                          {{ $t('general.final_completion_date') }}
                        </span>
                        <span class="result-tab__item-value">{{ end_date }}</span>
                      </li>
                    </ul>
                  </div>

                  <!-- QR Code section (edit mode only) -->
                  <div v-if="isEditMode && qrCodeCanBeShown" class="qr-code-section" style="margin-top: 24px;">
                    <div class="qr-code-section__inner">
                      <div class="qr-grid qr-grid--tab">
                        <div v-for="(item, qrIndex) in qr_text_array" :key="qrIndex" class="qr-card">
                          <div class="qr-card-header">
                            <h4 class="qr-card-title">{{ item.title }}</h4>
                          </div>
                          <div class="qr-card-body">
                            <QrCodeStyled :data="item.code" :download-file-name="item.title || 'qr-code'"
                                          :download-size="1000"
                                          :margin="10" :show-download="true"
                                          :size="160"
                                          background-color="#ffffff" corners-dot-color="#0c4a6e"
                                          corners-dot-type="dot" corners-square-color="#0c4a6e"
                                          corners-square-type="extra-rounded"
                                          dots-color="#1e3a5f" dots-type="rounded" error-correction-level="H"/>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="assignment-footer">
                  <button class="uk-button uk-button-outline small assignment-btn" type="button"
                          @click="switcherChange(settingsTabIndex)">
                    <i class="icon-feather-arrow-left"></i> {{ $t("general.previous") }}
                  </button>
                  <button class="uk-button uk-button-primary small assignment-btn" type="button" @click="saveForm">
                    <i class="icon-feather-arrow-right"></i> {{ $t("general.save") }}
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

    </div>

    <modal :adaptive="false" :clickToClose="true" height="auto" name="qr_code_for_classroom_education" width="80%"
           @before-close="handleModalClose">
      <div class="uk-modal-body"
           style="max-height: 80vh; max-width: 95vw; overflow-y: auto; padding: 20px; box-sizing: border-box;">
        <div class="qr-grid">
          <div v-for="(item, qrIndex) in qr_text_array" :key="qrIndex" class="qr-card">
            <div class="qr-card-header">
              <h4 class="qr-card-title">{{ item.title }}</h4>
            </div>
            <div class="qr-card-body">
              <QrCodeStyled :data="item.code" :download-file-name="item.title || 'qr-code'" :download-size="1000"
                            :margin="10" :show-download="true" :size="160" background-color="#ffffff"
                            corners-dot-color="#0c4a6e"
                            corners-dot-type="dot" corners-square-color="#0c4a6e" corners-square-type="extra-rounded"
                            dots-color="#1e3a5f" dots-type="rounded" error-correction-level="H"/>
            </div>
          </div>
        </div>
      </div>
    </modal>

    <div id="modal_customize" class="uk-flex-center customize-modal" uk-modal>
      <div class="uk-modal-dialog uk-margin-auto-vertical customize-modal__dialog">
        <!-- Header -->
        <div class="customize-modal__header">
          <div class="customize-modal__header-left">
            <i aria-hidden="true" class="uil-setting customize-modal__header-icon"></i>
            <h3 class="customize-modal__title">{{ $t('general.content_settings') }}</h3>
          </div>
          <button class="uk-modal-close customize-modal__close" type="button">
            <i class="icon-feather-x"></i>
          </button>
        </div>

        <!-- Body -->
        <div class="customize-modal__body">
          <div class="customize-modal__field">
            <label class="customize-modal__label">
              {{ $t('general.content_feature') }}
            </label>
            <multiple-select-input :model="contentFeatureOption"
                                   :show-labels="false"
                                   :values="contentFeatureOptions"
                                   class="customize-modal__dropdown"
                                   label="translatedName"
                                   track-by="type"
                                   @update:model="onContentFeatureChange"
            />
          </div>

          <template v-if="selectedContentFeature === 'timed_content'">
            <div class="customize-modal__field">
              <label class="customize-modal__label">
                {{ $t('general.start_date') }} <span class="required">*</span>
              </label>
              <VueCtkDateTimePicker v-model="contentsTimed[selectedEducationId].starts_at"
                                    :format="'YYYY-MM-DD HH:mm:ss'"
                                    :max-date="contentsTimed[selectedEducationId].ends_at"
                                    :min-date="setMinimumDate()"
              />
            </div>

            <div class="customize-modal__field">
              <label class="customize-modal__label">
                {{ $t('general.end_date') }} <span class="required">*</span>
              </label>
              <VueCtkDateTimePicker v-model="contentsTimed[selectedEducationId].ends_at"
                                    :format="'YYYY-MM-DD HH:mm:ss'"
                                    :min-date="contentsTimed[selectedEducationId].starts_at"
                                    :no-button-now="true"
              />
            </div>
          </template>
        </div>

        <!-- Footer -->
        <div class="customize-modal__footer">
          <button class="uk-modal-close customize-modal__btn customize-modal__btn--cancel" type="button">
            {{ $t('general.give_up') }}
          </button>
          <button :disabled="selectedContentFeature === 'timed_content' && !controlContentRequired"
                  class="customize-modal__btn customize-modal__btn--save"
                  type="button"
                  @click="saveContentFeatures()"
          >
            <i class="icon-feather-check"></i> {{ $t('general.save') }}
          </button>
        </div>
      </div>
    </div>

  </main>
</template>

<script>
import draggable from "vuedraggable";
import store from "@/core/services";
import UserGroupSelection from "@/view/components/assignment/UserGroupSelection";
import Content from "@//view/components/assignment/Content";
import Gift from "@//view/components/assignment/Gift";
import HtmlArea from "@/view/company/Mail/Html";
import Multiselect from "vue-multiselect";
import DefaultLoading from "@/view/components/loading/DefaultLoading";
import QrCodeStyled from "@/view/components/ui/QrCodeStyled";
import axios from "axios";
import assignment_module, {
  BASE_URL as ASSIGNMENT_BASE_URL,
  CREATE_ITEM as ASSIGNMENT_CREATE_ITEM,
  ERROR as ASSIGNMENT_ERROR,
  GET_ITEM as ASSIGNMENT_GET_ITEM,
  ITEM as ASSIGNMENT_ITEM,
  LOADING as ASSIGNMENT_LOADING,
  MODULE_NAME as ASSIGNMENT_MODULE_NAME,
  SET_ITEM as ASSIGNMENT_SET_ITEM,
  UPDATE_ITEM as ASSIGNMENT_UPDATE_ITEM,
} from "@/core/services/store/assignment.module";

import survey_module, {
  BASE_URL as SURVEY_BASE_URL,
  GET_ITEMS as SURVEY_GET_ITEMS,
  ITEMS as SURVEY_ITEMS,
  MODULE_NAME as SURVEY_MODULE_NAME,
} from "@/core/services/store/evaluation_survey.module";

import { GET_ITEM_DETAIL_BY_ID, GET_ITEMS } from "@/core/services/store/REST.module";
import { createQrCodeForEveryClassroomEducation } from "@/view/company/Assignments/helpers/qrCodeHelper";
import { convertLocalToUTC, convertUTCToLocal } from "@/utils/timeUtils";
import contentModule, {
  BASE_URL as CONTENT_BASE_URL,
  GET_ITEM,
  MODULE_NAME as CONTENT_MODULE_NAME
} from "@/core/services/store/content.module";

import certificate_module, {
  BASE_URL as CERTIFICATE_BASE_URL,
  GET_ITEMS as CERTIFICATE_GET_ITEMS,
  ITEMS as CERTIFICATE_ITEMS,
  MODULE_NAME as CERTIFICATE_MODULE_NAME,
} from "@/core/services/store/certificate.module";

import AppMultiselect from "@/view/components/select/app-multiselect/app-multiselect.vue";
import CompetenciesInputSelection from "@/view/components/input/CompetenciesInputSelection.vue";
import DateRangePicker from "@/view/components/ui/DateRangePicker.vue";
import AiCoverImageGenerator from "@/view/components/ai-cover-image/AiCoverImageGenerator.vue";
import CompanyBreadcrumb from "@/view/company/components/breadcrumb/CompanyBreadcrumb.vue";
import StepperBreadcrumb from "@/view/company/components/breadcrumb/StepperBreadcrumb.vue";
import bridge from "@/core/services/bridge.service";
import native from "@/mobile/mobile.fileHandler";
import MultipleSelectInput from "@/assets/components/inputs/MultipleSelectInput.vue";
import instructorService, {
  normalizeInstructor,
} from "@/core/services/instructor.service";

const _SURVEY_MODULE = SURVEY_MODULE_NAME;
const _ASSIGNMENT_MODULE = ASSIGNMENT_MODULE_NAME;
const _CONTENT_MODULE_NAME = CONTENT_MODULE_NAME;
const _CERTIFICATE_MODULE = CERTIFICATE_MODULE_NAME;

export default {
  name: "AssignmentAddUpdate",
  components: {
    CompetenciesInputSelection,
    AppMultiselect,
    UserGroupSelection,
    draggable,
    Content,
    Gift,
    Multiselect,
    HtmlArea,
    DefaultLoading,
    QrCodeStyled,
    DateRangePicker,
    AiCoverImageGenerator,
    CompanyBreadcrumb,
    StepperBreadcrumb,
    MultipleSelectInput,
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_SURVEY_MODULE, survey_module);
    registerStoreModule(_ASSIGNMENT_MODULE, assignment_module);
    registerStoreModule(_CONTENT_MODULE_NAME, contentModule);
    registerStoreModule(_CERTIFICATE_MODULE, certificate_module);
  },
  data() {
    return {
      activeTabIndex: 0,
      notification_send_type: 'now',
      notification_scheduled_at: null,
      selectedContentFeature: 'untimed_content',
      content_features: [{
        name: 'general.timed_content', type: 'timed_content', starts_at: 'null', ends_at: 'null'
      }, {
        name: 'general.untimed_content', type: 'untimed_content'
      }],
      contentsTimed: [],
      selectedEducationId: null,
      lastEndDate: null,
      lastStartDate: null,
      can_open_contents_in_order: true,
      qor_code_modal_title: this.$t("general.classroom_education_qr_code"),
      isClassRoomEducationSelected: false,
      durationFeatureIsEnabled: false,
      showModalLearning: false,
      restUrl: "api/mail-template/assignment",
      textarea_length: 0,
      successMessage: null,
      errorMessages: [],
      cover_image: null,
      cover_image_url: null,
      cover_image_link: null,
      _waitingForFile: false,
      checked_users: [],
      checked_groups: [],
      added_users: [],
      added_groups: [],
      name: null,
      is_compulsory: false,
      start_date: null,
      end_date: null,
      repeatable: false,
      repetition_no: 0,
      following_assignment_id: null,
      assignmentsList: [],
      assign_after_days: null,
      showCustomDayInput: false,
      customDays: null,
      duration: 0,
      survey_id: null,
      appear_top: false,
      survey_required: true,
      highlight_education: false,
      has_feedbacks: false,
      description: null,
      gift_rule_id: 1,
      has_present: 0,
      active_content_id: null,
      gifts: [],
      educations: [],
      repetition_date: [],
      has_customized_template: false,
      send_mail_notification: false,
      send_mobile_notification: false,
      can_be_added_to_calendar: false,
      can_be_watched_again: false,
      mail_template: [],
      mail_template_codes: [],
      company: [],
      all_selected_educations: [],
      all_selected_gifts: [],
      selected_content: null,
      _localLoading: false,
      item_loaded: false,
      show_only_unassigned_users: true,
      defaultLoadingModal: true,
      qrCodeCanBeShown: false,
      qr_text: null,
      remind_if_not_entered_x_days: 1,
      remind_if_not_entered_every_y_days: 1,
      remind_before_starting_x_days: 1,
      remind_before_starting_every_y_days: 1,
      remind_before_ending_x_days: 1,
      remind_before_ending_every_y_days: 1,
      isRemindEntered: false,
      isRemindStarting: false,
      isRemindEnding: false,
      qr_text_array: [],
      certificate: {},
      selectedCompetencies: [],
      selectedWidgets: [],
      widgetItems: [],
      instructorOptions: [],
      selectedInstructors: [],
      instructorsLoading: false,
      instructorsInitializedAssignmentId: null,
      is_competency_selected: false,
      mandatory_completion: false,
      status_id: true,
      initial_status_id: true,
      assignment_status_toggle: false
    };
  },
  computed: {
    isEditMode() {
      return this.$route.name === 'company.assignments.edit';
    },
    assignment_loading: {
      get() {
        if (this.isEditMode) {
          return store.getters[ASSIGNMENT_MODULE_NAME + "/" + ASSIGNMENT_LOADING];
        }
        return this._localLoading;
      },
      set(value) {
        this._localLoading = value;
      },
    },
    showLoading() {
      if (this.isEditMode) {
        return (this.assignment_loading || !this.formattedAssignmentItem) && this.defaultLoadingModal;
      }
      return this.assignment_loading;
    },
    giftHasPresent: {
      get() {
        return this.isEditMode ? this.assignment_item?.has_present : this.has_present;
      },
      set(value) {
        if (this.isEditMode) {
          if (this.assignment_item) this.assignment_item.has_present = value;
        } else {
          this.has_present = value;
        }
      },
    },
    localStartDate: {
      get() {
        return this.start_date;
      },
      set(value) {
        this.start_date = value;
      },
    },
    localEndDate: {
      get() {
        return this.end_date;
      },
      set(value) {
        this.end_date = value;
      },
    },
    disabledAddContent() {
      if (!this.isEditMode) return false;
      const data = this.assignment_item?.completed_content_details;
      if (Array.isArray(data)) {
        return data.length > 0;
      }
      if (data && typeof data === 'object') {
        return Object.keys(data).length > 0;
      }
      return false;
    },
    assignment_status_action_label() {
      return this.initial_status_id
          ? this.$t('general.do_assignment_passive')
          : this.$t('general.do_assignment_active');
    },
    formattedAssignmentItem() {
      if (!this.isEditMode) return true;
      let self = this;
      let item = self.assignment_item;

      self.item_loaded = false;
      if (item == null || item.users == undefined) return false;
      if (String(item.id) !== String(self.$route.params.id)) return false;
      self.textarea_length = item.description.length;
      self.added_users = item.users;
      self.name = item.name;
      self.description = item.description;
      self.is_compulsory = this.normalizeIsCompulsory(item.is_compulsory);
      self.start_date = convertUTCToLocal(item.start_date);
      self.end_date = convertUTCToLocal(item.end_date);
      self.repeatable = item.repeatable;
      self.repeatable = !!item.order_number;
      self.duration = item.duration;
      self.repetition_no = item.repetition_no;
      self.survey_id = item.evaluation_survey_id;
      self.appear_top = item.appear_top;
      self.certificate = item.certificate;

      (item.send_mail_notification || item.send_mail_notification === 1) ? self.send_mail_notification = true : self.send_mail_notification = false;
      (item.send_mobile_notification || item.send_mobile_notification === 1) ? self.send_mobile_notification = true : self.send_mobile_notification = false;
      (item.can_be_added_to_calendar || item.can_be_added_to_calendar === 1) ? self.can_be_added_to_calendar = true : self.can_be_added_to_calendar = false;
      (item.can_be_watched_again || item.can_be_watched_again === 1) ? self.can_be_watched_again = true : self.can_be_watched_again = false;
      (item.has_customized_template || item.has_customized_template === 1) ? self.has_customized_template = true : self.has_customized_template = false;
      if (item.has_customized_template && self.mail_template.html != undefined) {
        self.mail_template.html = item.mail_template;
        self.mail_template.subject = item.mail_subject ?? item.subject ?? null;
      }
      self.has_feedbacks = item.has_feedbacks == true ? true : false;
      self.survey_required = item.survey_required;
      self.highlight_education = item.highlight_education;
      self.mandatory_completion = item.mandatory_completion == true ? true : false;
      self.can_open_contents_in_order = item.can_open_contents_in_order;
      self.gift_rule_id = item.gift_rule_id;
      self.gifts = item.gifts;
      self.educations = item.educations;
      self.all_selected_educations = item.all_selected_educations;
      self.all_selected_gifts = item.all_selected_gifts;
      self.cover_image_link = item.cover_image_link;
      const assignmentId = String(item.id);
      if (self.instructorsInitializedAssignmentId !== assignmentId) {
        self.selectedInstructors = Array.isArray(item.instructors)
            ? item.instructors.map(normalizeInstructor)
            : [];
        self.instructorsInitializedAssignmentId = assignmentId;

        const knownInstructorIds = new Set(
            self.instructorOptions.map((instructor) => instructor.id)
        );
        self.selectedInstructors.forEach((instructor) => {
          if (!knownInstructorIds.has(instructor.id)) {
            self.instructorOptions.push(instructor);
          }
        });
      }
      self.status_id = item.status_id == true || item.status_id === 1 || item.status_id === "1" ? true : false;
      self.initial_status_id = self.status_id;
      self.assignment_status_toggle = false;
      if (self.widgetItems.length) {
        self.selectedWidgets = self.widgetItems.filter((w) => (item.selected_widgets || []).includes(w.id));
      }
      self.item_loaded = true;

      if (item.remind_if_not_entered_x_days) {
        this.isRemindEntered = true;
        this.remind_if_not_entered_x_days = item.remind_if_not_entered_x_days;
        this.remind_if_not_entered_every_y_days = item.remind_if_not_entered_every_y_days;
      }
      if (item.remind_before_starting_x_days) {
        this.isRemindStarting = true;
        this.remind_before_starting_x_days = item.remind_before_starting_x_days;
        this.remind_before_starting_every_y_days = item.remind_before_starting_every_y_days;
      }
      if (item.remind_before_ending_x_days) {
        this.isRemindEnding = true;
        this.remind_before_ending_x_days = item.remind_before_ending_x_days;
        this.remind_before_ending_every_y_days = item.remind_before_ending_every_y_days;
      }

      if (item.followup_assignment_id) {
        this.following_assignment_id = { id: item.followup_assignment_id };
      }
      if (item.notification_scheduled_at) {
        this.notification_scheduled_at = convertUTCToLocal(item.notification_scheduled_at);
        this.notification_send_type = 'scheduled';
      } else {
        this.notification_scheduled_at = null;
      }

      if (item.assign_after_days) {
        const days = item.assign_after_days;
        const predefinedOptions = [
          { value: 365, label: this.$t('general.365-days-later') },
          { value: 180, label: this.$t('general.180-days-later') },
          { value: 90, label: this.$t('general.90-days-later') },
          { value: 15, label: this.$t('general.15-days-later') }
        ];
        const matchedOption = predefinedOptions.find(opt => opt.value === days);
        if (matchedOption) {
          this.assign_after_days = matchedOption;
          this.customDays = days;
          this.showCustomDayInput = false;
        } else {
          this.customDays = days;
          this.showCustomDayInput = true;
          this.assign_after_days = null;
        }
      }

      return true;
    },
    breadcrumbItems() {
      return [
        { name: this.$t("menu.company_dashboard.assignments") },
        { name: this.$t(this.isEditMode ? "general.edit_assignment" : "menu.company_dashboard.create_assignment") },
      ];
    },
    stepperItems() {
      const items = [
        { icon: "icon-feather-flag", label: this.$t("login.header") },
        { icon: "uil-book-open", label: this.$t("messages.content") },
        { icon: "uil-users-alt", label: this.$t("users.users") },
      ];
      if (this.$isGiftVisible) {
        items.push({ icon: "uil-gift", label: this.$t("general.gift") });
      }
      items.push(
          { icon: "uil-cog", label: this.$t("general.settings") },
          { icon: "uil-invoice", label: this.$t("general.overview") }
      );
      return items;
    },
    settingsTabIndex() {
      return this.$isGiftVisible ? 4 : 3;
    },
    resultTabIndex() {
      return this.$isGiftVisible ? 5 : 4;
    },
    compulsoryOptions() {
      return [
        { id: 1, name: this.$t("assignment.compulsory") },
        { id: 0, name: this.$t("assignment.not_compulsory") },
      ];
    },
    contentFeatureOptions() {
      return this.content_features.map((f) => ({
        ...f,
        translatedName: this.$t(f.name),
      }));
    },
    contentFeatureOption() {
      return this.contentFeatureOptions.find((o) => o.type === this.selectedContentFeature) || this.contentFeatureOptions[1];
    },
    assignAfterDaysOptions() {
      return [
        { value: 365, label: this.$t("general.365-days-later") },
        { value: 180, label: this.$t("general.180-days-later") },
        { value: 90, label: this.$t("general.90-days-later") },
        { value: 15, label: this.$t("general.15-days-later") },
        { value: "custom", label: this.$t("general.other") },
      ];
    },
    selectedCompulsory: {
      get() {
        return this.compulsoryOptions.find((o) => o.id === (this.is_compulsory ? 1 : 0)) || this.compulsoryOptions[0];
      },
      set(value) {
        this.is_compulsory = value && value.id === 1;
      },
    },
    giftRuleOptions() {
      return [
        { id: 1, name: this.$t("general.fastest_to_complete") },
      ];
    },
    selectedGiftRule: {
      get() {
        return this.giftRuleOptions.find((o) => o.id === Number(this.gift_rule_id)) || this.giftRuleOptions[0];
      },
      set(value) {
        this.gift_rule_id = value && value.id ? Number(value.id) : 1;
      },
    },
    certificate_items: {
      get() {
        return store.getters[CERTIFICATE_MODULE_NAME + "/" + CERTIFICATE_ITEMS];
      },
      set(value) {
      },
    },
    controlContentRequired() {
      if (!this.contentsTimed[this.selectedEducationId].starts_at || !this.contentsTimed[this.selectedEducationId].ends_at)
        return false
      return true
    },
    assignment_item: {
      get() {
        return store.getters[ASSIGNMENT_MODULE_NAME + "/" + ASSIGNMENT_ITEM];
      },
      set(value) {
      },
    },
    survey_items: {
      get() {
        return store.getters[SURVEY_MODULE_NAME + "/" + SURVEY_ITEMS];
      },
      set(value) {
      },
    },
    error: {
      get() {
        return store.getters[ASSIGNMENT_MODULE_NAME + "/" + ASSIGNMENT_ERROR];
      },
      set(value) {
      },
    },
  },
  methods: {
    normalizeIsCompulsory(value) {
      if (typeof value === "boolean") return value;
      if (typeof value === "number") return value === 1;
      if (typeof value === "string") {
        const normalized = value.toLowerCase();
        return normalized === "true" || normalized === "1";
      }
      return false;
    },
    getCompetencyTooltip(competencies) {
      if (!competencies || competencies.length === 0) {
        return '';
      }

      let tooltipText = '';
      competencies.forEach((competency, index) => {
        tooltipText += `• ${competency.name}`;
        if (index < competencies.length - 1) {
          tooltipText += '<br>';
        }
      });

      return `title: ${tooltipText}`;
    },
    getImageUrl() {
      if (this.cover_image_url) {
        return this.cover_image_url;
      }

      if (this.cover_image_link) {
        return this.cover_image_link;
      }

      if (this.cover_image && typeof this.cover_image === 'string') {
        return this.cover_image
      }

      return require('@/assets/images/no-photo.png');
    },
    processFile(event) {
      if (!event.target.files[0]) return;
      this.cover_image = event.target.files[0];
      this.cover_image_url = URL.createObjectURL(this.cover_image);
    },
    handleAiCoverImageSelected({ file, previewUrl }) {
      this.cover_image = file;
      this.cover_image_url = previewUrl;
    },
    setMinMaxTime() {
      if (!this.lastEndDate) {
        this.lastEndDate = new Date();
      }
      if (!this.lastStartDate) {
        this.lastStartDate = new Date();
      }
      this.contentsTimed.forEach((content) => {
        if (this.lastEndDate.getTime() < new Date(content.ends_at).getTime()) {
          this.lastEndDate = new Date(content.ends_at);
        }
        if (this.lastStartDate.getTime() > new Date(content.starts_at).getTime())
          this.lastStartDate = new Date(content.starts_at);
      })
    },
    saveContentFeatures() {
      if (this.selectedContentFeature === 'timed_content') {
        this.setMinMaxTime();
      }
      this.contentsTimed[this.selectedEducationId].type = this.selectedContentFeature;
      this.selectedContentFeature === 'untimed_content';
      UIkit.modal("#modal_customize").hide();
    },
    showCustomize(id, index) {
      this.selectedEducationId = index;
      if (!this.contentsTimed[index]) {
        this.contentsTimed.push({
          id: id,
          type: 'untimed_content',
          starts_at: null,
          ends_at: null
        });
      } else {
        this.selectedContentFeature = this.contentsTimed[index].type
      }
      UIkit.modal("#modal_customize").show();
    },
    onContentFeatureChange(value) {
      this.selectedContentFeature = value ? value.type : 'untimed_content';
    },
    hideSomeInputsForClassRoomEducation: function () {
      // @todo: move central place
      this.isClassRoomEducationSelected = false;

      let isClassRoomEducationSelected = false;
      let repeatable = false;

      const containsAnyClassRoomEducation = this.educations.some(
          (education) => education.name === this.$t("documents.classroom_education")
      );
      if (containsAnyClassRoomEducation) {
        isClassRoomEducationSelected = true;
        repeatable = false;
      }

      this.repeatable = repeatable;
      this.isClassRoomEducationSelected = isClassRoomEducationSelected;
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
          charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          charCode === 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    getAssignmentItem() {
      this.selectedInstructors = [];
      this.instructorsInitializedAssignmentId = null;
      this.$store.commit(
          ASSIGNMENT_MODULE_NAME + "/" + ASSIGNMENT_SET_ITEM,
          null
      );

      this.$store.dispatch(ASSIGNMENT_MODULE_NAME + "/" + ASSIGNMENT_GET_ITEM, {
        url: ASSIGNMENT_BASE_URL + "/" + this.$route.params.id,
      }).then((response) => {

        this.qr_text_array = createQrCodeForEveryClassroomEducation({
          result: response,
          assignmentId: this.assignment_item.id
        });

        this.selectedCompetencies = response.competencies;

        if (this.selectedCompetencies?.length > 0) {
          this.is_competency_selected = true;
        }

        response.contents_programs?.forEach((data) => {
          this.contentsTimed.push({
            id: data?.id,
            type: data?.pivot?.timed_content_type ?? "untimed_content",
            starts_at: data?.pivot?.starts_at,
            ends_at: data?.pivot?.ends_at,
          });
        });

        this.setMinMaxTime();
      });
    },
    decideQrCodeForShowing() {
      const containsAnyClassRoomEducation = this.educations.some(
          (education) => education.name === 'documents.classroom_education'
      );
      this.qrCodeCanBeShown = containsAnyClassRoomEducation;
    },
    getMailTemplateData() {
      let self = this;
      self.$store
          .dispatch(GET_ITEM_DETAIL_BY_ID, {
            url: self.restUrl,
            acceptPromise: false,
          })
          .then((result) => {
            if (typeof result !== 'undefined' && result.status) {
              self.company = result.data.company;
              const template = result.data.template;
              if (self.isEditMode && self.assignment_item?.has_customized_template) {
                template.html = self.assignment_item.mail_template;
                template.subject = self.assignment_item.mail_subject ?? self.assignment_item.subject ?? null;
              }
              self.mail_template = template;
              self.mail_template_codes = result.data.codes;
            }
          });
    },
    async getInstructorOptions() {
      this.instructorsLoading = true;
      try {
        const activeInstructors =
            await instructorService.listActiveInstructorOptions();
        const activeInstructorIds = new Set(
            activeInstructors.map((instructor) => instructor.id)
        );
        const selectedInstructorsNotInOptions = this.selectedInstructors.filter(
            (instructor) => !activeInstructorIds.has(instructor.id)
        );

        this.instructorOptions = [
          ...activeInstructors,
          ...selectedInstructorsNotInOptions,
        ];
      } catch (error) {
        this.instructorOptions = [];
        this.errorMessages.push(
            this.$t("general.instructor_list_load_failed")
        );
      } finally {
        this.instructorsLoading = false;
      }
    },
    saveForm() {
      this.assignment_loading = true;
      let self = this;
      if (!this.isValidFields("ALL")) {
        this.assignment_loading = false;
        return;
      }

      if (self.duration == "" || self.duration < 0) self.duration = 0;
      let formData = new FormData();

      // Contents assembly using timedMap approach (robust for both modes)
      const timedMap = new Map(
          (this.contentsTimed || []).map(item => [item.id, item])
      );

      if (this.educations?.length > 0) {
        this.educations.forEach((edu, index) => {
          const timed = timedMap.get(edu.id);

          formData.append(`contents[${index}][id]`, edu.id);
          formData.append(
              `contents[${index}][starts_at]`,
              convertLocalToUTC(timed?.starts_at || null)
          );
          formData.append(
              `contents[${index}][ends_at]`,
              convertLocalToUTC(timed?.ends_at || null)
          );
          formData.append(
              `contents[${index}][type]`,
              timed?.type || null
          );
        });
      }

      formData.append("name", self.name);
      formData.append("description", self.description);
      formData.append("certificate_id", self.certificate?.id || null);
      const instructorIds = self.selectedInstructors
          .map((instructor) => Number(instructor.id))
          .filter(Number.isFinite);
      if (instructorIds.length) {
        instructorIds.forEach((id) => {
          formData.append("instructor_ids[]", id);
        });
      } else if (this.isEditMode) {
        formData.append("instructor_ids", "null");
      }

      // has_present: Edit uses assignment_item.has_present, Add uses local
      formData.append(
          "has_present",
          this.isEditMode
              ? (self.assignment_item.has_present == true ? 1 : 0)
              : (self.has_present === true ? 1 : 0)
      );
      formData.append("gift_rule_id", self.gift_rule_id);
      self.gifts.forEach((element) => {
        formData.append("gifts[]", element.id);
      });
      formData.append("is_user", self.checked_users.length > 0 ? 1 : 0);
      formData.append("users", self.checked_users);
      formData.append("is_group", self.checked_groups.length > 0 ? 1 : 0);
      self.checked_groups.forEach((element) => {
        formData.append("groups[]", element);
      });
      formData.append("is_compulsory", self.is_compulsory ? 1 : 0);

      // Dates: Edit uses flat keys, Add uses dates array
      if (this.isEditMode) {
        formData.append("start_date", convertLocalToUTC(self.start_date));
        formData.append("end_date", convertLocalToUTC(self.end_date));
      } else {
        formData.append("dates[" + 0 + "][start_date]", convertLocalToUTC(self.start_date));
        formData.append("dates[" + 0 + "][end_date]", convertLocalToUTC(self.end_date));
      }

      if (this.notification_send_type === 'scheduled' && this.notification_scheduled_at) {
        const schedVal = this.isEditMode
            ? convertLocalToUTC(this.notification_scheduled_at.replace("T", " ").replace(".000000Z", ""))
            : convertLocalToUTC(this.notification_scheduled_at);
        formData.append("notification_scheduled_at", schedVal);
      }

      formData.append(
          "highlight_education",
          self.highlight_education === true || self.highlight_education == true ? 1 : 0
      );
      formData.append("mandatory_completion", self.mandatory_completion === true || self.mandatory_completion == true ? 1 : 0);
      formData.append(
          "can_open_contents_in_order",
          self.can_open_contents_in_order
      );
      formData.append("duration", self.duration);
      formData.append("survey_required", self.survey_required ? 1 : 0);
      if (self.survey_required === true || self.survey_required == true) {
        formData.append("evaluation_survey_id", this.isEditMode ? self.survey_id : self.survey_id.id);
      }
      formData.append(
          "send_mail_notification",
          self.send_mail_notification === true ? 1 : 0
      );
      formData.append(
          "send_mobile_notification",
          self.send_mobile_notification === true ? 1 : 0
      );
      formData.append(
          "can_be_added_to_calendar",
          self.can_be_added_to_calendar === true ? 1 : 0
      );
      formData.append(
          "can_be_watched_again",
          self.can_be_watched_again === true ? 1 : 0
      );
      formData.append(
          "has_customized_template",
          self.has_customized_template === true ? 1 : 0
      );
      if (self.has_customized_template === true) {
        formData.append("mail_template", self.mail_template.html);
        formData.append(
            "mail_subject",
            typeof self.mail_template.subject === "string"
                ? self.mail_template.subject.trim()
                : ""
        );
      }
      formData.append("has_feedbacks", self.has_feedbacks === true ? 1 : 0);
      formData.append("appear_top", self.appear_top === true ? 1 : 0);

      // Status: only in Edit mode
      if (this.isEditMode) {
        const nextStatusId = self.assignment_status_toggle ? !self.initial_status_id : self.initial_status_id;
        formData.append("status_id", nextStatusId == true ? 1 : 0);
      }

      // Cover image
      if (this.isEditMode) {
        if (self.cover_image) formData.append("cover_image", self.cover_image);
      } else {
        formData.append("cover_image", self.cover_image);
      }

      // Repeatable (Add mode only)
      if (!this.isEditMode) {
        formData.append("repeatable", self.repeatable === true ? 1 : 0);
        formData.append(
            "repetition_no",
            self.repeatable ? self.repetition_no : 0
        );
      }

      if (self.following_assignment_id) {
        formData.append("followup_assignment_id", self.following_assignment_id.id);

        let daysToSend = null;
        if (self.showCustomDayInput && self.customDays) {
          daysToSend = self.customDays;
        } else if (self.assign_after_days && typeof self.assign_after_days === 'object') {
          daysToSend = self.assign_after_days.value;
        }

        if (daysToSend && daysToSend !== 'custom') {
          formData.append("assign_after_days", daysToSend);
        }
      } else {
        formData.append("followup_assignment_id", null);
        formData.append("assign_after_days", null);
      }

      // Reminders: Edit sends null when disabled, Add skips entirely
      if (this.isRemindEntered) {
        formData.append("remind_if_not_entered_x_days", self.remind_if_not_entered_x_days);
        formData.append("remind_if_not_entered_every_y_days", self.remind_if_not_entered_every_y_days);
      } else if (this.isEditMode) {
        formData.append("remind_if_not_entered_x_days", null);
        formData.append("remind_if_not_entered_every_y_days", null);
      }
      if (this.isRemindStarting) {
        formData.append("remind_before_starting_x_days", self.remind_before_starting_x_days);
        formData.append("remind_before_starting_every_y_days", self.remind_before_starting_every_y_days);
      } else if (this.isEditMode) {
        formData.append("remind_before_starting_x_days", null);
        formData.append("remind_before_starting_every_y_days", null);
      }
      if (this.isRemindEnding) {
        formData.append("remind_before_ending_x_days", self.remind_before_ending_x_days);
        formData.append("remind_before_ending_every_y_days", self.remind_before_ending_every_y_days);
      } else if (this.isEditMode) {
        formData.append("remind_before_ending_x_days", null);
        formData.append("remind_before_ending_every_y_days", null);
      }

      if (this.is_competency_selected) {
        this.selectedCompetencies.forEach((item) => formData.append("competencies[]", item.id));
      }

      this.selectedWidgets.forEach((item) => formData.append("widgets[]", item.id));

      // Repetition dates (Add mode only)
      if (!this.isEditMode && self.repeatable) {
        for (let i = 1; i <= self.repetition_no; i++) {
          if (
              self.repetition_date[i].start_date >
              self.repetition_date[i].end_date
          ) {
            this.errorMessages.push(
                this.$t("general.start_date_must_be_before_end")
            );
            return false;
          }
          formData.append(
              "dates[" + i + "][start_date]",
              convertLocalToUTC(self.repetition_date[i].start_date)
          );
          formData.append(
              "dates[" + i + "][end_date]",
              convertLocalToUTC(self.repetition_date[i].end_date)
          );
        }
      }

      // Dispatch: Edit uses UPDATE, Add uses CREATE
      const action = this.isEditMode
          ? ASSIGNMENT_MODULE_NAME + "/" + ASSIGNMENT_UPDATE_ITEM
          : ASSIGNMENT_MODULE_NAME + "/" + ASSIGNMENT_CREATE_ITEM;
      const url = this.isEditMode
          ? ASSIGNMENT_BASE_URL + "/update/" + this.$route.params.id
          : ASSIGNMENT_BASE_URL;

      store
          .dispatch(action, {
            url: url,
            contents: formData,
          })
          .then((result) => {
            self.assignment_loading = false;
            self.scrollToTop();

            if (this.isEditMode) {
              this.defaultLoadingModal = false;
            }

            if (!this.error) {
              if (this.isEditMode) {
                this.successMessage = self.$t("general.successfully_updated");
              }
            } else {
              this.errorMessages.push(this.error);
            }

            this.qr_text_array = createQrCodeForEveryClassroomEducation({
              result,
              assignmentId: this.assignment_item.id
            });

            if (this.qr_text_array?.length) {
              if (!this.isEditMode) {
                this.successMessage = self.$t("general.successfully_created");
              }
              this.$modal.show("qr_code_for_classroom_education");
            } else {
              if (this.isEditMode) {
                setTimeout(() => {
                  this.handleModalClose();
                }, 500);
              } else {
                this.handleModalClose();
              }
            }
          })
          .catch((error) => {
            if (error.response && error.response.status === 422) {
              const errors = error.response.data?.errors || {};
              this.errorMessages = [];

              Object.values(errors).forEach((msgArr) => {
                this.errorMessages.push(...msgArr);
              });

              const message = error.response.data?.message;
              if (message && !this.errorMessages.includes(message)) {
                this.errorMessages.unshift(message);
              }
            }
            self.assignment_loading = false;
          });
    },
    handleModalClose() {
      this.$router.push({ name: "company.assignments.list" });
    },
    updateMailTemplate(newCode) {
      if (
          this.mail_template.is_linked &&
          (!newCode.includes("{SLINK}") || !newCode.includes("<!--BUTTON-->"))
      ) {
        this.errorMessages.push(
            this.$t("validation.required_field").replace(":NAME", "{SLINK}")
        );
        return false;
      }
      this.mail_template.html = newCode;
      if (this.isEditMode && this.assignment_item?.mail_template != undefined && newCode) {
        this.assignment_item.mail_template = newCode;
      }
    },
    codeSlice() {
      if (this.mail_template_codes.length === undefined) return 0;
      return Math.ceil(this.mail_template_codes.length / 2);
    },
    copyCode(code) {
      const el = document.createElement("textarea");
      el.value = code;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      const selected =
          document.getSelection().rangeCount > 0
              ? document.getSelection().getRangeAt(0)
              : false;
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
    },
    async addContentToAssignment(item) {
      let edu_id = item.id;

      // Prevent adding the same item twice
      if (this.all_selected_educations.includes(edu_id)) return false;

      // Detect if item is a program
      const isProgram = item.name === "documents.program";

      // Add file_category_id based on item type
      const preparedItem = {
        ...item,
        file_category_id: isProgram ? 11 : 1
      };

      // 1) SINGLE CONTENT: Check conflict with existing program
      if (!isProgram) {
        const existingProgram = this.educations.find(e => e.name === "documents.program");
        if (existingProgram) {
          const tempItems = [
            { id: existingProgram.id, file_category_id: 11 },
            { id: preparedItem.id, file_category_id: 1 }
          ];
          try {
            await axios.post('/api/assignment/unique-content-validate', { items: tempItems });
          } catch (err) {
            if (err.response?.status === 422) {
              UIkit.notification({
                message: this.$t('general.same_content_in_program'),
                status: 'danger',
                pos: 'top-center',
                timeout: 4000
              });
              return false;
            }
          }
        }

        // No conflict → add single content
        this.hideSomeInputsForClassRoomEducation();
        this.educations.push(preparedItem);
        this.all_selected_educations.push(edu_id);
        return true;
      }

      // 2) PROGRAM: Validate with all existing items
      const tempItems = this.educations.concat(preparedItem).map(x => ({
        id: x.id,
        file_category_id: x.file_category_id ?? (x.name === "documents.program" ? 11 : 1)
      }));

      try {
        await axios.post('/api/assignment/unique-content-validate', { items: tempItems });

        // No conflict → add program
        this.hideSomeInputsForClassRoomEducation();
        this.educations.push(preparedItem);
        this.all_selected_educations.push(edu_id);

      } catch (err) {
        if (err.response?.status === 422) {
          UIkit.notification({
            message: this.$t('general.same_content_in_program'),
            status: 'danger',
            pos: 'top-center',
            timeout: 4000
          });
          return false;
        }

        UIkit.notification({
          message: this.$t('general.program_add_validation_error'),
          status: 'danger',
          pos: 'top-center',
          timeout: 4000
        });
        return false;
      }
    },
    addGiftToAssignment(item) {
      let gift_id = item.id;
      this.all_selected_gifts.push(gift_id);
      this.gifts.push(item);
    },
    removeGiftFromAssignment(id) {
      let gifts = this.gifts;
      let gifts_ids_all = this.all_selected_gifts;
      let pos = gifts
          .map(function (x) {
            return x;
          })
          .indexOf(id);
      let pos_all = gifts_ids_all
          .map(function (x) {
            return x;
          })
          .indexOf(id);
      gifts.splice(pos, 1);
      gifts_ids_all.splice(pos_all, 1);
      return true;
    },
    removeContentFromAssignment(education, index) {
      const edu_id = education.id;

      let educations = this.educations;
      let educations_ids_all = this.all_selected_educations;

      let pos_all = educations_ids_all.map((x) => x).indexOf(edu_id);

      let edu_pos = educations.map((x) => x.id).indexOf(edu_id);

      educations.splice(edu_pos, 1);
      educations_ids_all.splice(pos_all, 1);
      this.contentsTimed.splice(index, 1)
      this.hideSomeInputsForClassRoomEducation();
      return true;
    },
    async getSurveys() {
      let self = this;
      await this.$store.dispatch(SURVEY_MODULE_NAME + "/" + SURVEY_GET_ITEMS, {
        url: SURVEY_BASE_URL,
        filters: {
          is_active: 1,
          order: "asc",
          sort: "id",
          fields: "id,name,is_default",
        },
      });

      let survey = this.survey_items.find(
          (item) => parseInt(item.is_default) === 1
      );
      if (typeof survey !== "undefined") {
        self.survey_id = {
          id: survey.id,
          name: survey.name,
        };
      }
    },
    resetMessages() {
      this.successMessage = null;
      this.errorMessages = [];
    },
    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    },
    getResultsAll() {
      this.getMailTemplateData();
      if (this.isEditMode) {
        this.getAssignmentItem();
      }
      this.getSurveys();
    },
    onCoverPhotoInputClick(event) {
      if (!bridge.isNative) return;
      event.preventDefault();
      this._waitingForFile = true;
      native.pickFile("image/*");
    },
    triggerCoverPhotoInput() {
      if (bridge.isNative) {
        this._waitingForFile = true;
        native.pickFile("image/*");
        return;
      }
      const input = this.$refs.coverPhotoInput;
      if (!input) return;
      input.value = null;
      input.click();
    },
    applyCoverPhoto(file) {
      if (!file) return;
      this.cover_image = file;
      this.cover_image_url = URL.createObjectURL(file);
    },
    isValidFields(fields) {
      let self = this;

      self.resetMessages();

      if (fields !== "ALL") {
        fields--;
      }

      const indexOfEntryTab = 0;
      const indexOfContentTab = 1;
      const indexOfUsersTab = 2;
      const indexOfGiftTab = 3;

      if (fields === "ALL" || fields === indexOfEntryTab) {
        if (self.name == null || self.name?.length === 0) {
          return self.showFieldsFailedError(
              indexOfEntryTab,
              self.$t("validation.required_field").replace(":NAME", self.$t('general.assignment_name'))
          );
        }

        if (self.description === null || self.description?.length === 0) {
          return self.showFieldsFailedError(
              indexOfEntryTab,
              self.$t("validation.required_field").replace(":NAME", self.$t('general.description'))
          );
        }

        if (!this.isEditMode && self.cover_image === null) {
          return self.showFieldsFailedError(
              indexOfEntryTab,
              self.$t("content.required.cover_photo")
          );
        }
      }

      if ((fields === "ALL" || fields === indexOfContentTab) && self.all_selected_educations.length === 0) {
        return self.showFieldsFailedError(
            indexOfContentTab,
            self.$t("validation.required_field").replace(":NAME", self.$t('messages.content'))
        );
      }

      if ((fields === "ALL" || fields === indexOfUsersTab) && self.checked_users.length === 0 && self.checked_groups.length === 0) {
        return self.showFieldsFailedError(
            indexOfUsersTab,
            self.$t("validation.required_field").replace(":NAME", self.$t('users.users'))
        );
      }

      if (this.$isGiftVisible && (fields === "ALL" || fields === indexOfGiftTab) && self.giftHasPresent && self.all_selected_gifts.length === 0) {
        return self.showFieldsFailedError(
            indexOfGiftTab,
            self.$t("validation.required_field").replace(":NAME", self.$t('general.gift'))
        );
      }

      let indexOfSettingsTab = this.$isGiftVisible && fields === 3 ? 5 : 4;

      if (fields === "ALL" || fields === indexOfSettingsTab) {
        if (self.start_date == null) {
          return self.showFieldsFailedError(
              indexOfSettingsTab,
              self.$t("validation.required_field").replace(":NAME", self.$t('general.start_day'))
          );
        }

        if (self.end_date == null) {
          return self.showFieldsFailedError(
              indexOfSettingsTab,
              self.$t("validation.required_field").replace(":NAME", self.$t('general.final_completion_date'))
          );
        }

        if (self.duration === "" || self.duration < 0) {
          self.duration = 0;
        }

        if (self.repeatable && self.repetition_no <= 0) {
          return self.showFieldsFailedError(
              indexOfSettingsTab,
              self.$t("validation.required_field").replace(":NAME", self.$t('general.number_of_repetitions'))
          );
        }

        if (self.survey_required && (self.survey_id == null || !self.survey_id)) {
          return self.showFieldsFailedError(
              indexOfSettingsTab,
              self.$t("validation.required_field").replace(":NAME", self.$t('general.the_survey'))
          );
        }

        if (self.has_customized_template && (self.mail_template.html == null || self.mail_template.html === "")) {
          return self.showFieldsFailedError(
              indexOfSettingsTab,
              self.$t("validation.required_field").replace(":NAME", self.$t('general.the_email_template'))
          );
        }
        if (self.following_assignment_id) {
          let daysValue = null;
          if (self.showCustomDayInput) {
            daysValue = self.customDays;
          } else if (self.assign_after_days && typeof self.assign_after_days === 'object') {
            daysValue = self.assign_after_days.value;
          }

          if (!daysValue || daysValue === 'custom' || daysValue <= 0) {
            return self.showFieldsFailedError(
                indexOfSettingsTab,
                self.$t("validation.required_field").replace(":NAME", self.$t('general.assign-after-days'))
            );
          }
        }
      }

      return true;
    },
    showFieldsFailedError(index, message) {
      this.errorMessages.push(message);
      this.scrollToTop();
      this.switcherChange(index);

      return false;
    },
    validateAndSwitch(index) {
      let areAllFieldsValid = this.isValidFields(index);
      if (areAllFieldsValid) {
        this.switcherChange(index);
      }

      if (index === this.settingsTabIndex) {
        this.hideSomeInputsForClassRoomEducation();
      }

      if (this.isEditMode && index === this.resultTabIndex) {
        this.decideQrCodeForShowing();
      }
    },
    onStepperChange(index) {
      if (index === this.settingsTabIndex) {
        this.hideSomeInputsForClassRoomEducation();
      }
      this.switcherChange(index);
    },
    switcherChange(index) {
      this.activeTabIndex = index;
    },
    setMinimumDate(start_date = null) {
      let date = new Date();
      if (start_date) {
        let startDate = new Date(start_date);
        date = new Date(startDate.getTime() + 86400000); // + 1 day in ms
      }
      return date.toISOString().split("T")[0];
    },
    async getItemInUrlDetail() {
      const { id: contentId, name: contentName, title: contentTitle } = this.$route.params
      let fetchedContent = null;

      if (contentId) {
        // içerikler sayfasından içeriklere tıklandığında params degeri olarak id-name-title değerleri geliyor

        try {
          fetchedContent = await store.dispatch(CONTENT_MODULE_NAME + "/" + GET_ITEM, {
            url: CONTENT_BASE_URL + "/" + contentId,
          });

          const contentData = fetchedContent.data || fetchedContent;

          this.name = contentData.title || "";
          this.description = contentData.description || "";
          this.cover_image = contentData.cover_photo || null;
          this.selectedInstructors = Array.isArray(contentData.instructors)
              ? contentData.instructors.map(normalizeInstructor)
              : [];

          this.selected_content = {
            id: contentId,
            title: contentData.title || "",
            name: contentData.file_category?.name || "",
            competencies: contentData.competencies || []
          };

          if (this.selected_content) {
            this.addContentToAssignment(this.selected_content);
          }
        } catch (error) {
          console.error("İçerik verisi alınamadı:", error);
        }
      }

    },
    getWidgets() {
      axios.get('/api/widgets/assignment/list').then((response) => {
        const locale = this.$i18n.locale;
        this.widgetItems = response.data.map((item) => ({
          ...item,
          title: item.lang_title && item.lang_title[locale] ? item.lang_title[locale] : item.title
        }));
      });
    },
    getCertificates() {
      this.$store.dispatch(
          CERTIFICATE_MODULE_NAME + "/" + CERTIFICATE_GET_ITEMS,
          {
            url: CERTIFICATE_BASE_URL,
            filters: {
              status_id: 1,
              order: "asc",
              sort: "id",
            },
          }
      );
    },
    async getAssignments() {
      try {
        const response = await this.$store.dispatch(GET_ITEMS, {
          url: 'api/assignment',
          filters: {
            search: '',
            sort: 'desc',
            order_by: 'created_at',
            status_id: 1,
            by_user: false,
          },
        });

        if (response && response.data) {
          this.assignmentsList = response.data.map(assignment => ({
            id: assignment.id,
            name: assignment.name,
          }));

          // In edit mode, resolve the following_assignment_id to full object
          if (this.isEditMode && this.following_assignment_id && this.following_assignment_id.id && this.assignmentsList.length > 0) {
            const fullAssignment = this.assignmentsList.find(a => a.id === this.following_assignment_id.id);
            if (fullAssignment) {
              this.following_assignment_id = fullAssignment;
            }
          }
        }
      } catch (error) {
        this.assignmentsList = [];
      }
    },
  },
  async mounted() {
    this.getResultsAll();

    if (!this.$isGiftVisible) {
      this.has_present = 0;
    }
    this.$forceUpdate();

    if (this.isEditMode) {
      // QR text setup for edit mode
      this.qr_text = `${window.location.origin}/#/assignments/${this.$route.params.id}/classroom-education`;
    } else {
      // Add mode: delayed modal + content from URL params
      setTimeout(() => {
        this.showModalLearning = true;
      }, 1000);

      try {
        await this.getItemInUrlDetail()
      } catch (error) {
        console.error("getItemInUrlDetail hatası:", error);
      }

      // Native bridge setup (Add mode only)
      if (bridge.isNative) {
        this._unsubscribePickFile = bridge.on("PICK_FILE_RESULT", (payload) => {
          if (!this._waitingForFile) return;
          this._waitingForFile = false;

          if (!payload.success || !payload.file) return;
          const { name, type, base64 } = payload.file;

          const byteString = atob(base64);
          const ab = new ArrayBuffer(byteString.length);
          const ia = new Uint8Array(ab);
          for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
          }
          this.applyCoverPhoto(new File([ab], name, { type }));
        });
      }
    }

    this.getCertificates();
    this.getAssignments();
    this.getWidgets();
    this.getInstructorOptions();
  },
  watch: {
    assignment_loading(val) {

    },
    widgetItems(newVal) {
      if (this.isEditMode && newVal && newVal.length && this.assignment_item?.selected_widgets?.length) {
        this.selectedWidgets = newVal.filter((w) => this.assignment_item.selected_widgets.includes(w.id));
      }
    },
    description(val) {
      this.textarea_length = val.length;
    },
    repetition_no(val) {
      let date = new Date();
      let end_date = new Date(date.getTime() + 86400000)
          .toISOString()
          .split("T")[0];
      let start_date = date.toISOString().split("T")[0];
      if (val) {
        for (let index = 1; index <= val; index++) {
          this.repetition_date[index] = {};
          this.repetition_date[index].start_date = start_date;
          this.repetition_date[index].end_date = end_date;
        }
      }
    },
    survey_items(value) {
      if (value && value.length)
        setTimeout(() => {
          $(".selectpicker_survey").selectpicker();
        }, 500);
    },
    successMessage() {
      this.debouncedResetValues();
    },
    errorMessages() {
      this.debouncedResetValues();
    },
    can_be_added_to_calendar(val) {
      val ? this.send_mail_notification = val : null;
      this.can_be_added_to_calendar = val;
    },
    send_mail_notification(val) {
      !val ? this.can_be_added_to_calendar = val : null;
      this.send_mail_notification = val;
    },
    send_mobile_notification(val) {
      this.send_mobile_notification = val;
    },
    following_assignment_id(newVal) {
      if (!newVal) {
        this.assign_after_days = null;
        this.showCustomDayInput = false;
        this.customDays = null;
      }
    },
    assign_after_days(newVal) {
      if (newVal && newVal.value === 'custom') {
        this.showCustomDayInput = true;
        this.customDays = null;
      } else if (newVal && typeof newVal === 'object' && newVal.value !== 'custom') {
        this.customDays = newVal.value;
      }
    },
  },
  created: function () {
    this.debouncedResetValues = _.debounce(this.resetMessages, 3000);
  },

  beforeDestroy() {
    const modal = UIkit.modal("#modal_learning");
    if (modal) modal.$destroy(true);

    const modalGift = UIkit.modal("#modal_gifts");
    if (modalGift) modalGift.$destroy(true);

    const modalCustomize = UIkit.modal("#modal_customize");
    if (modalCustomize) modalCustomize.$destroy(true);

    // ✅ Sayfadan çıkınca değeri sıfırla
    this.notification_scheduled_at = null;

    if (this._unsubscribePickFile) {
      this._unsubscribePickFile();
    }
  }
};
</script>


<style scoped src="./AssignmentAddUpdate/scoped.css"></style>
<style src="./AssignmentAddUpdate/global.css"></style>
